function obligatory() {
  let submitAndCreateNewButton = $('#submit-and-create-new');
  let toggle = $('#toggle-checkbox');
  let obligatoryCheckbox = $('.obligatory-checkbox');

  obligatoryCheckbox.on('click', function () {
    sendObligatory($(this).parent().find('input[type=checkbox]'));
  });

  submitAndCreateNewButton.on('click', function (event) {
    event.preventDefault();
    window.location = $(this).data('url');
  });

  function sendObligatory(checkbox) {
    let isAdded = !checkbox.is(':checked');
    console.log(checkbox, isAdded);
    let url = $('#form-obligatory-url').data('update-url');
    $.ajax({
      type: 'POST',
      url: url,
      data: { 'obligatory-insurance': isAdded ? checkbox.data('id') : null },
      success: function (data) {
        //TODO nastavit např. zelený box u serial number
      },
    });
  }

  let sendButton = $('#continue_to_payment_button');

  sendButton.on('click', function (event) {
    let obligatoryAlert = $('.obligatory-alert-validation');
    if (toggle.is(':checked')) {
      event.preventDefault();

      let isValid = true;
      let customSelect = $('.custom-select');
      customSelect.each(function () {
        let text = $(this).find('.select-selected').text();
        if (text === 'Vyberte limit') {
          isValid = false;
        }
      });

      if (isValid === true) {
        window.location = $(this).attr('href');
      } else {
        obligatoryAlert.removeClass('is-hidden');
      }
    } else {
      window.location = $(this).attr('href');
    }
  });
}
